module.exports = __webpack_public_path__ + "static/media/reciclado.7038aabc.png";